.overlay {
  overflow: auto;
}
